import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { ICommunicationsEmail } from "./communicationsEmail.type"
import { CommunicationsEmail } from "./communicationsEmail"

export interface ICommunicationsEmailRaw {
  id: number
  processed_at: string | null
  opened: boolean
  subject?: string
  html_content: string | null
}

export interface ICommunicationsEmailRawData {
  emails: ICommunicationsEmailRaw[]
}

export const CommunicationsEmailParser: IParser<
  ICommunicationsEmail,
  ICommunicationsEmailRaw
> = {
  toDomain: (data: ICommunicationsEmailRaw) => {
    try {
      return new CommunicationsEmail(
        data.id,
        data.subject ?? "",
        dayjs(data.processed_at),
        data.opened,
        data.html_content,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
